var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnifeGypsyJackknife({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "91.917px",
    height: "31.583px",
    viewBox: "0 0 91.917 31.583",
    enableBackground: "new 0 0 91.917 31.583",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selected_Items"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M32.893,10.707v0.225h0.274v-0.22l9.901-0.274l1.03-0.604 l0.282,0.253l1.118-0.683l0.354,0.219l1.106-0.613l0.356,0.204c1.006-0.794,1.811-1.141,2.412-1.042 c0.22,0.034,0.34,0.121,0.362,0.264c0.023,0.142-0.064,0.27-0.26,0.38c-0.325,0.185-0.544,0.401-0.661,0.649 c-0.104,0.219-0.114,0.438-0.034,0.656c0.077,0.206,0.213,0.368,0.41,0.492c0.206,0.125,0.428,0.174,0.668,0.148v0.795h0.215v-0.57 l3.089,0.376v0.567h0.225v-0.671c5.453,0.518,10.45,0.33,15-0.568l14.679,5.917c-0.907,0.704-2.414,1.6-4.518,2.69 c-2.105,1.09-4.401,1.697-6.887,1.822c-2.487,0.124-4.617-0.062-6.388-0.551c-1.772-0.489-4.205-1.121-7.292-1.898 c-3.09-0.78-5.804-1.183-8.139-1.213c-0.01-0.077-0.042-0.165-0.09-0.262c-0.098-0.197-0.243-0.347-0.425-0.451 c-0.186-0.103-0.383-0.157-0.59-0.171h-0.144c-0.17,1.248-0.504,2.195-1.001,2.843c-4.658-1-9.536-1.547-14.627-1.639V17.59 l-0.291-0.008v0.213c-10.026-0.095-16.556,0.37-19.596,1.398c-3.457,1.063-7.002,2.866-10.634,5.413 c-1.738,0.187-1.931-1.318-0.581-4.522c1.674-2.315,4.385-4.312,8.134-5.992C14.099,12.405,21.613,11.276,32.893,10.707z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "guides"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnifeGypsyJackknife);
export default __webpack_public_path__ + "static/media/knife_gypsy_jackknife.6e3101a9613f3519694729cc12d93206.svg";
export { ForwardRef as ReactComponent };